import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from './plugins/axios';

Vue.prototype.axios = axios;
Vue.prototype.url = require('../config/global').url

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
